export default "__VITE_ASSET__bf3bd46f__"